import { useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { forgotPassword } from '../api/services'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const extractError = (err) => {
    const detail = err?.response?.data?.detail
    if (typeof detail === 'string') return detail
    if (!err?.response) return 'Unable to reach the server. Please check your connection.'
    return 'Something went wrong. Please try again.'
}

export default function ForgotPassword() {
    const [email, setEmail] = useState('')
    const [submitted, setSubmitted] = useState(false)
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const isMounted = useRef(true)
    useEffect(() => {
        isMounted.current = true
        return () => { isMounted.current = false }
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError('')
        setLoading(true)

        try {
            await forgotPassword({ email: email.trim().toLowerCase() })
            if (isMounted.current) setSubmitted(true)
        } catch (err) {
            if (isMounted.current) setError(extractError(err))
        } finally {
            if (isMounted.current) setLoading(false)
        }
    }

    return (
        <div className="min-h-screen bg-brand-navy flex flex-col">
            <Navbar />

            <div className="flex-1 flex items-center justify-center px-4 sm:px-6 py-12">
                <div className="w-full max-w-md">

                    <div className="mb-8">
                        <h1 className="font-display text-3xl font-bold text-brand-text mb-2">
                            Reset your password
                        </h1>
                        <p className="text-brand-muted font-body text-sm">
                            Remembered it?{' '}
                            <Link
                                to="/login"
                                className="text-brand-amber hover:text-brand-amber2 transition-colors"
                            >
                                Back to sign in
                            </Link>
                        </p>
                    </div>

                    {submitted ? (
                        <div className="card">
                            <p className="text-brand-text font-body text-sm leading-relaxed mb-2">
                                If that email is registered, a reset link is on its way.
                            </p>
                            <p className="text-brand-muted font-body text-sm leading-relaxed">
                                Check your inbox and follow the link to set a new password.
                                The link expires in 15 minutes.
                            </p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-5">
                            <div>
                                <label className="label">Email address</label>
                                <input
                                    name="email"
                                    type="email"
                                    placeholder="Email address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="input-field"
                                    required
                                    disabled={loading}
                                    autoComplete="email"
                                />
                            </div>

                            {error && (
                                <div className="border border-red-500/30 bg-red-500/10 rounded px-4 py-3">
                                    <p className="text-red-400 text-sm font-body">{error}</p>
                                </div>
                            )}

                            <button
                                type="submit"
                                disabled={loading}
                                className="btn-primary w-full text-center disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {loading ? 'Sending reset link…' : 'Send reset link'}
                            </button>
                        </form>
                    )}

                    <p className="mt-6 text-center text-brand-muted text-xs font-body">
                        Your messages are never stored.
                    </p>

                </div>
            </div>

            <Footer />
        </div>
    )
}